<template>
	<div class="m-portlet m-portlet--brand">
		<div class="m-portlet__head">
			<div class="m-portlet__head-caption">
				<div class="m-portlet__head-title">
					<h3 class="m-portlet__head-text">
						Cấu hình tự động tăng cò theo mức điểm
					</h3>
				</div>
			</div>
			<div class="m-portlet__head-tools">
				<button v-if="false" @click="this.showTangCoForm" type="button" class="btn btn-brand m-btn m-btn--custom">Thêm cấu hình</button>
			</div>
		</div>
		<div class="m-portlet__body">
			<!--begin::Section-->
			<div class="m-section">
				<div class="m-section__content">
					<table class="table table-striped- table-bordered table-hover table-checkable" id="autoCommissionTable">
						<thead>
							<tr>
								<th nowrap></th>
								<th>Mức giới hạn (điểm)</th>
								<th>Tăng lên</th>
							</tr>
						</thead>
						<tbody id="autoCommissionBody"></tbody>
					</table>
				</div>
			</div>
			<!--end::Section-->

			<div v-if="false" class="modal fade show" id="tangcoForm" tabindex="-1" role="dialog" aria-labelledby="modalTitle">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h3 class="modal-title" id="modalTitle">Config tự động tăng cò</h3>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div class="modal-body">
							<form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
								<div class="form-group m-form__group row">
									<div class="col-lg-12">
										<span class="m-form__help">Áp dụng cho</span>
									</div>
									<div class="col-lg-4">
										<input disabled="true" type="text" class="form-control m-input" :value="this.user.code" />
									</div>
									<div class="col-lg-8">
										<input type="text" class="form-control m-input" v-model="subCode" />
									</div>
								</div>
								<game-info-selection :onlyToday="false" tab="" />
								<div class="form-group m-form__group row">
									<div class="col-lg-12">
										<span class="m-form__help">Nhập vào mức giới hạn</span>
										<input type="text" id="_limit_point" class="form-control m-input" placeholder="Mức giới hạn" />
									</div>
								</div>
								<div class="form-group m-form__group row">
									<div class="col-lg-12">
										<span class="m-form__help">Nhập mức tăng</span>
										<input type="text" id="incr" class="form-control m-input" placeholder="Mức tăng" />
									</div>
								</div>
							</form>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
							<button @click="this.addAutoCommission" type="button" class="btn btn-primary">Tăng</button>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import DataTable from "../DataTable";
	import GameInfoSelection from './GameInfoSelection';

	export default {
		data(){
			let vm = this;

	        return {
	        	"tableHeader": ["Tài khoản","Miền","Đài","Kiểu","Mức giới hạn","Mức tăng"],
	        	"columnSearch": [{pos:0}, {pos:1}, {pos:2}, {pos:3}, {pos:4}, {pos:5}],
	        	"tableColumns": [{data: 'user_code'},{data: 'game_id'},{data: 'channel_id'},{data: 'prop_id'},{data: 'point'},{data: 'incr'}],
	        	"columnDefs": [
					{
						targets: 1,
						render: function(data, type, full, meta) {
							let g = vm.gameInfo.games[data];
							return g;
						},
					},
					{
						targets: 2,
						render: function(data, type, full, meta) {
							if(data == "") return "Tất cả";
							let channels = [];
							for(let i=0;i<data.length;i++){
								let channel = [];
								for(let j=0;j<data[i].length;j++){
									channel.push(vm.gameInfo.channels[data[i][j]].alias);
								}

								channels.push(channel.join(" - "))
							}
							
							return channels.join(", ");
						},
					},
					{
						targets: 3,
						render: function(data, type, full, meta) {
							if(data == "") return "Tất cả";
							let props = [];
							for(let i=0;i<data.length;i++){
								props.push(vm.gameInfo.props[data[i]]);
							}
							
							return props.join(", ");
						},
					}
				],

	            "today": moment().format('DD/MM/Y'),
	            "commission": [],
	            "subCode": "",
	            "selectedRecord": null
	        }
	    },

	    created(){
    		this.getIncrCommission();
    	},

    	computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},

	    methods: {
	        getIncrCommission: function(){
	        	let vm = this;

	        	window.axios.get("admin-panel/tools/auto-commission")
	        				.then((res) => {
	        					res = res.data;
	        					// vm.commission = res.data;
	        					vm.generateTableContent(res.data);
	        					vm.initTable();
	        				})
	        				.catch((error) => {

	        				});
	        },

	        generateTableContent: function(data){
	        	let groups = Object.keys(data);
	        	let tbody = "";
	        	for (let i = 0; i < groups.length; i++) {
	        		let group = groups[i].split("|");
	        		let g = this.gameInfo.games[group[0]];
	        		let p = this.gameInfo.props[group[2]];
	        		let c = this.getChannelAlias(group[1]);
	        		let steps = Object.keys(data[ groups[i] ]);
	        		
	        		for (let j = 0; j < steps.length; j++) {
	        			tbody += "<tr>";
	        			tbody += 	"<td>"+g+" | " + (c == "" ? "" : c+" | ") + p + "</td>";
	        			tbody += 	"<td>" + steps[j] + "</td>";
	        			tbody += 	"<td>" + data[ groups[i] ][ steps[j] ] + "</td>";
	        		}
	        		
	        		tbody += "</tr>";
	        	}

	        	$("#autoCommissionBody").html(tbody);
	        },

	        getChannelAlias: function(channel){
	        	if(channel == "") return "";

	        	let cs = channel.split(",");
	        	let arr = [];

	        	for (let i = 0; i < cs.length; i++) {
	        		let c = cs[i].split(".");
	        		if(c == "") continue;

	        		let arr1 = [];
	        		for (let j = 0; j < c.length; j++) {
	        			arr1.push(this.gameInfo.channels[ c[j] ].alias);
	        		}
	        		
	        		arr.push(arr1.join(" - "));
	        	}

	        	return arr.join(", ");
	        },

	        initTable: function(){
	        	let tb = $("#autoCommissionTable");
	        	tb.DataTable({
					responsive: true,
					rowGroup: {
						dataSrc: 0,
					},
					displayLength: 100,
					columnDefs: [
			            { "visible": false, "targets": 0 }
			        ],
				});
	        }
	    }
	}

</script>